export default __webpack_public_path__ + "static/media/section-3-right-2.fe9fa15a.png";